import React, { useState, useEffect } from 'react';
import { ResultCard } from './ResultCard';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

const apikey = '0b5d97f803320088e910eb9594d31ac1';
const Add = () => {
	const [ query, setQuery ] = useState('');
	const [ results, setResults ] = useState([]);

	const onChange = (e) => {
		e.preventDefault();

		setQuery(e.target.value);

		fetch(
			`https://api.themoviedb.org/3/search/movie?api_key=${apikey}&language=en-US&page=1&include_adult=false&query=${e
				.target.value}`
		)
			.then((res) => res.json())
			.then((data) => {
				if (!data.errors) {
					setResults(data.results);
				} else {
					setResults([]);
				}
			});
	};

	const [devidedResult, setDevidedResult] = useState([])
	const split = (array, n) =>
		array.reduce(
			(a, c, i) => (i % n == 0 ? [ ...a, [ c ] ] : [ ...a.slice(0, -1), [ ...a[a.length - 1], c ] ]),
			[]
		);

	useEffect(
		() => {
			setDevidedResult(split(results, 4));
			console.log(devidedResult)
		},
		[ results ]
	);

	return (
		<div className="add-page">
			<div className="container">
				<div className="add-content">
					<TextField
						id="standard-basic"
						label="《Enter》 to search"
						placeholder="Search for a movie"
						value={query}
						onChange={onChange}
						fullWidth
					/>

					{/* {results.length > 0 && (
						<ul className="results">
							{results.map((movie) => (
								<li key={movie.id}>
									<ResultCard movie={movie} />
								</li>
							))}
						</ul>
					)} */}
					{devidedResult.map((fourMovies, i) => (
						<Grid container spacing={3} key={i} className="mt-5">
							{fourMovies.map((movie, j)=> <Grid item sm={3} xs={6} className="results" key={j}><ResultCard movie={movie} /></Grid>)}
						</Grid>
					))}
				</div>
			</div>
		</div>
	);
};
export default Add;
